var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#747480"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 25.3337H16M33.3333 14.667V20.0003M22.6667 14.667V20.0003M22.4 41.3337H33.6C35.8402 41.3337 36.9603 41.3337 37.816 40.8977C38.5686 40.5142 39.1805 39.9023 39.564 39.1496C40 38.294 40 37.1739 40 34.9337V23.7337C40 21.4934 40 20.3733 39.564 19.5177C39.1805 18.765 38.5686 18.1531 37.816 17.7696C36.9603 17.3337 35.8402 17.3337 33.6 17.3337H22.4C20.1598 17.3337 19.0397 17.3337 18.184 17.7696C17.4314 18.1531 16.8195 18.765 16.436 19.5177C16 20.3733 16 21.4934 16 23.7337V34.9337C16 37.1739 16 38.294 16.436 39.1496C16.8195 39.9023 17.4314 40.5142 18.184 40.8977C19.0397 41.3337 20.1598 41.3337 22.4 41.3337Z",
    stroke: "#FAFAFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.fea257b559cd0824945925f66cf77c03.svg";
export { ForwardRef as ReactComponent };